/* DEX for Business · site.js */

(function () {
  'use strict';

  /* ── Nav scroll + mobile menu ─────────────────────────────── */
  const nav = document.getElementById('site-nav');
  if (nav) {
    const SCROLL_THRESHOLD = 40;

    function updateNav() {
      if (window.scrollY > SCROLL_THRESHOLD) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    }
    updateNav();
    window.addEventListener('scroll', updateNav, { passive: true });

    // Mobile toggle
    const toggle = document.getElementById('nav-mobile-toggle');
    if (toggle) {
      toggle.addEventListener('click', () => {
        nav.classList.toggle('menu-open');
        document.body.style.overflow = nav.classList.contains('menu-open') ? 'hidden' : '';
        toggle.setAttribute('aria-expanded', nav.classList.contains('menu-open'));
      });
    }

    // Close mobile menu on link click
    nav.querySelectorAll('.nav-links a').forEach(link => {
      link.addEventListener('click', () => {
        nav.classList.remove('menu-open');
        document.body.style.overflow = '';
      });
    });

    // Dropdown hover with close delay (prevents flicker on mouse travel)
    nav.querySelectorAll('.nav-dropdown').forEach(dropdown => {
      let closeTimer;
      const menu = dropdown.querySelector('.nav-dropdown-menu');
      const open = () => {
        clearTimeout(closeTimer);
        if (menu) { menu.style.opacity='1'; menu.style.pointerEvents='auto'; menu.style.transform='translateX(-50%) translateY(0)'; }
      };
      const close = () => {
        closeTimer = setTimeout(() => {
          if (menu) { menu.style.opacity=''; menu.style.pointerEvents=''; menu.style.transform=''; }
        }, 180);
      };
      dropdown.addEventListener('mouseenter', open);
      dropdown.addEventListener('mouseleave', close);
      if (menu) { menu.addEventListener('mouseenter', open); menu.addEventListener('mouseleave', close); }
    });

  // Active nav link detection
    const page = location.pathname.split('/').pop() || 'index.html';
    const solutionPages = [
      'capability-assessment.html',
      'workforce-capability-mapping.html',
      'leadership-feedback.html',
      'capability-benchmarking.html',
      'organizational-capability-review.html',
      'enterprise-pilot.html',
      'annual-recertification.html'
    ];
    nav.querySelectorAll('.nav-link[href]').forEach(link => {
      const href = link.getAttribute('href');
      if (href === page) link.classList.add('active');
      if (href === 'index.html' && (page === '' || page === 'index.html')) link.classList.add('active');
    });
    // Mark Solutions as active for solution pages
    const solTrigger = nav.querySelector('.nav-dropdown-trigger');
    if (solTrigger && solutionPages.includes(page)) {
      solTrigger.classList.add('active');
    }
  }

  /* ── Fade-in intersection observer ───────────────────────── */
  function initFadeIn() {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      document.querySelectorAll('.fade-in').forEach(el => el.classList.add('visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          const delay = parseInt(e.target.dataset.delay || '0', 10);
          setTimeout(() => e.target.classList.add('visible'), delay);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -32px 0px' });

    document.querySelectorAll('.fade-in').forEach((el, i) => {
      if (el.closest('.hero')) { el.classList.add('visible'); return; }
      // Stagger siblings
      const parent = el.parentElement;
      if (parent) {
        const siblings = parent.querySelectorAll(':scope > .fade-in');
        const idx = Array.from(siblings).indexOf(el);
        if (idx > 0) el.dataset.delay = String(idx * 60);
      }
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeIn);
  } else {
    initFadeIn();
  }

  /* ── FAQ accordion ────────────────────────────────────────── */
  function initFAQ() {
    document.querySelectorAll('.faq-item').forEach(item => {
      const btn = item.querySelector('.faq-q');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');
        // Close all in same FAQ container
        const parent = item.closest('.faq');
        if (parent) {
          parent.querySelectorAll('.faq-item.open').forEach(o => o.classList.remove('open'));
        }
        if (!isOpen) item.classList.add('open');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQ);
  } else {
    initFAQ();
  }

  /* ── Number counter animation ─────────────────────────────── */
  function initCounters() {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-count]').forEach(el => {
      const target = parseInt(el.dataset.count, 10);
      if (reduced) { el.textContent = target; return; }
      const io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          const start = performance.now();
          const dur = 900;
          const tick = (now) => {
            const p = Math.min(1, (now - start) / dur);
            const e = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(target * e);
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
          io.disconnect();
        }
      }, { threshold: 0.3 });
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCounters);
  } else {
    initCounters();
  }

  /* ── Homepage hero bloom animation ───────────────────────── */
  const heroBloom = document.getElementById('hero-bloom');
  if (heroBloom) {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced) {
      let t = 0, raf;
      const tick = () => {
        t += 0.0035;
        const x = 68 + Math.sin(t) * 6;
        const y = 32 + Math.cos(t * 0.8) * 4;
        const x2 = 18 + Math.cos(t * 0.6) * 5;
        heroBloom.style.background =
          `radial-gradient(58% 56% at ${x}% ${y}%, rgba(24,118,211,0.28), transparent 68%),` +
          `radial-gradient(50% 50% at ${x2}% 88%, rgba(11,61,110,0.55), transparent 70%),` +
          `linear-gradient(165deg,#0B3D6E 0%,#08294C 55%,#061B38 100%)`;
        raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    }
  }

  /* ── Inquiry type switcher (start page) ───────────────────── */
  const typeSelect = document.getElementById('inquiry-type');
  if (typeSelect) {
    typeSelect.addEventListener('change', () => {
      document.querySelectorAll('[data-inquiry]').forEach(el => {
        el.style.display = 'none';
      });
      const target = document.querySelector(`[data-inquiry="${typeSelect.value}"]`);
      if (target) target.style.display = 'block';
    });
  }

})();
